(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxClassDialogController', TaxClassDialogController);

    TaxClassDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TaxClass'];

    function TaxClassDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TaxClass) {
        var vm = this;
        vm.taxClass = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:taxClassUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.taxClass.id !== null) {
                TaxClass.update(vm.taxClass, onSaveSuccess, onSaveError);
            } else {
                TaxClass.save(vm.taxClass, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
